<template>
    <div class="newsPart" :style="{background:'url('+ bg + ') no-repeat center',backgroundSize:'100% 100%'}">
        <YYTitle :yyMsg="yyMessage" class="hidden-xs-only"></YYTitle>
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>

        <el-row type="flex">
            <el-col :xs="24" :sm="12">
                <div 
                    class="newsLeft" 
                    v-if="newsList && newsList.length !== 0" 
                    @click="go_detail({id:newsList[0].newsId,type:'0'})"
                    role="button"
                    tabindex="0"
                    @keydown.enter="go_detail({id:newsList[0].newsId,type:'0'})"
                    :aria-label="'查看新闻：' + newsList[0].newsTitle"
                >
                    <div class="hidden-xs-only">
                        <img 
                            :src="newsList[0].newsImg?'/else'+newsList[0].newsImg:defaultImg"
                            :alt="newsList[0].newsImg ? newsList[0].newsTitle : '新闻中心默认配图'"
                            loading="lazy"
                            decoding="async"
                        >
                    </div>
                    <div class="intro">
                        <div class="left hidden-sm-and-up">
                            <p>{{timeTrans[0].month}}</p>
                            <p>{{timeTrans[0].year}}</p>
                        </div>
                        <div class="right">
                            <h5>{{newsList[0].newsTitle}}</h5>
                            <p>{{newsList[0].newsIntro}}</p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="12">
                <div class="newsRight" v-if="newsList && newsList.length !== 0">
                    <div 
                        class="rlist" 
                        v-for="(item,index) in newsList.slice(1,5)" 
                        :key="index" 
                        @click="go_detail({id:item.newsId,type:'0'})"
                        role="button"
                        tabindex="0"
                        @keydown.enter="go_detail({id:item.newsId,type:'0'})"
                        :aria-label="'查看新闻：' + item.newsTitle"
                    >
                        <div class="left">
                            <p>{{timeTrans[index].month}}</p>
                            <p>{{timeTrans[index].year}}</p>
                        </div>
                        <div class="right">
                            <h5>{{item.newsTitle}}</h5>
                            <p>{{item.newsIntro}}</p>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <MoreButton @toLink="parentLink" aria-label="前往新闻中心查看全部资讯"></MoreButton>
    </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'
import MoreButton from './moreButton.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    props:{
        bg: String
    },
    data(){
        return{
            yyMessage: '新闻中心',
            titEN: 'NEWS CENTER',
            defaultImg: require('@/assets/nBig.jpg')
        }
    },
    computed:{
        ...mapState({
            newsList: state => state.news.newsList,
            newsCount: state => state.news.newsCount,
        }),
        ...mapGetters({
            timeTrans: 'news/time_transfer',
        })
    },
    components:{
        YYTitle,
        XSTitle,
        MoreButton
    },
    created(){
        this._get_newsList()
    },
    methods:{
        parentLink(){
            this.$router.replace('/news')
            this.go_news()
        },

        ...mapActions({
            get_newsList: 'news/get_and_change_newsList',
            go_detail: 'news/go_detail_from_index',
            go_news:'news/go_news_from_button'
        }),

        _get_newsList(){
            this.get_newsList({
                limit: 5,
                type: "0",
                page: 1
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.newsPart{
    padding: vw(110) vw(361) vw(57);

    .newsLeft,
    .newsRight{
        color: $whiteFB;
        text-align: left;

        h5,p{
            overflow: hidden;
            text-overflow: ellipsis;
        }

        h5{
            font-size: vw(18);
            font-weight: 500;
            white-space: nowrap;
        }

        p{
            font-size: vw(14);
            margin: 0;
        }

    }

    .newsLeft{
        transition: transform .5s ease-out;

        &:hover{
            cursor: pointer;
            transform: translateY(vw(-30));
        }

        img{
            max-width: vw(550);
            height: vw(200);
        }

        .intro{
            .right{
                max-width: vw(500);

                h5{
                    margin: vw(30) 0 vw(23);
                }

                p{
                    line-height: 1.7;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -moz-box;
                    -moz-line-clamp: 2;
                    -moz-box-orient: vertical;
                    word-wrap: break-word;
                    word-break: break-all;
                }
            }
        }

    }

    .newsRight{
        .rlist{
            display: flex;
            margin-bottom: vw(35);
            transition: transform .4s ease-out;

            &:hover{
                transform: translateX(vw(30));
                cursor: pointer;
            }

            .left{
                padding-right: vw(13);
                border-right: 2px solid white;

                p{
                    text-align: right;
                    line-height: 1.4;

                    &:first-child{
                        font-size: vw(24);
                    }

                    &:last-child{
                        font-size: vw(16);
                    }

                }
            }

            .right{
                padding-left: vw(13);
                max-width: vw(482);

                h5{
                    margin: 0;
                    margin-bottom: vw(12);
                }

                p{
                    font-size: vw(14);
                    white-space: nowrap;
                }
            }
        }
    }

    ::v-deep {
        .el-row{
            justify-content: center;
            flex-wrap: wrap;
            padding: vw(74) 0 vw(44);
        }

        .cusTitle{
            font-size: vw(30);
            color: white;
            font-weight: 500;

            &:after{
                content: 'NEWS';
                color: white;
                font-size: vw(72);
                top: vw(-32);
                left: vw(473);
                font-weight: 800;
                opacity: 0.4;
            }
        }

        .moreBu{
            margin: 0 auto;
            color: $blue043;
            background: white;
            transition: all .1s linear;

            &:hover,
            &:active{
                box-shadow: 0 0 4px 5px rgba(175,252,255,.3);
            }
        }
    }

    // -------------------------------  手机端  -------------------------------
    @media only screen and (max-width: 767px){
        padding-top: 0;

        .newsLeft .intro,
        .newsRight .rlist{
            margin-bottom: vp(28);
            align-items: center;

            .left{
                padding: vp(36) vp(20) vp(27) vp(18);
                background: $grayEF;

                p{
                    color: $font66;

                    &:first-child{
                        font-size: vp(36);
                    }

                    &:last-child{
                        font-size: vp(24);
                    }
                }
            }

            .right{
                max-width: vp(519);
                padding-left: vp(24);

                h5,p{
                    color: black;
                }

                h5{
                    padding: 0;
                    margin: 0;
                    margin-bottom: vp(12);
                    font-size: vp(30);
                    font-weight: 800;
                }

                p{
                    font-size: vp(18);
                }
            }
        }

        .newsLeft{
            .intro{
                display: flex;

                .left{
                    p{
                        text-align: right;
                        line-height: 1.4;
                    }
                }
            }
        }

        .newsRight{
            .rlist{
                padding-top: vp(28);
                border-top: vp(2) solid $grayEF;

                .left{
                    border-right: 0;
                }

                .right{
                    p{
                        white-space: normal;
                        line-height: 1.7;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        display: -moz-box;
                        -moz-line-clamp: 2;
                        -moz-box-orient: vertical;
                        word-wrap: break-word;
                        word-break: break-all;
                    }
                }
            }
        }

        ::v-deep {
            .el-row{
                padding-top: 0;
            }

            .moreBu{
                color: white;
                background: linear-gradient(180deg, rgba(37,99,175,.8), $yyBlue);
                transition: all .1s linear;

                &:hover,
                &:active{
                    box-shadow: 0 0 4px 5px rgba(37,99,175,.2);
                }

                &:active{
                    background: linear-gradient(180deg, $yyBlue, rgba(37,99,175,.8));
                }
            }
        }
    }
}
</style>